
import {
    defineAsyncComponent,
    onMounted,
    ref,
    watch,
} from 'vue';

import useInventarios from '../composables/useInventarios';

import numeral from 'numeral';

export default {
    components: {
        KardexEditarEntradaSalidaComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/KardexEditarEntradaSalidaComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerKardexProductos,
        } = useInventarios();

        const headers = [
            { text: 'Producto',        value: 'nombre_producto', sortable: true },
            { text: 'Marca',           value: 'nombre_marca',    sortable: true },
            { text: 'Sd. Inicial',     value: 'saldo_inicial',   sortable: true },
            { text: 'Entradas',        value: 'entradas',        sortable: true },
            { text: 'Salidas',         value: 'salidas',         sortable: true },
            { text: 'Saldo',           value: 'saldo',           sortable: true },
            { text: 'Val. Entradas',   value: 'valor_entradas',  sortable: true },
            { text: 'Costo Salidas',   value: 'costo_salidas',   sortable: true },
            { text: 'Val. Saldo',      value: 'valor_saldo',     sortable: true },
            { text: 'Ingreso Ventas',  value: 'ingreso_ventas',  sortable: true },
            { text: 'Costo Ventas',    value: 'costo_ventas',    sortable: true },
            { text: 'Utilidad Bruta',  value: 'utilidad_bruta',  sortable: true },
        ];

        const kardexs      = ref<any[]>([]);
        const totalItems   = ref(0);
        const loading      = ref(false);
        const textoFiltro  = ref('');
        let   searchTimer: any = null;

        const serverOptions = ref({
            page: 1,
            rowsPerPage: 25,
        });

        const kardexEditarEntradaSalidaComponentRef = ref();

        const buscarKardex = async () => {
            loading.value = true;
            const resp = await obtenerKardexProductos(
                serverOptions.value.page,
                serverOptions.value.rowsPerPage,
                textoFiltro.value,
            );
            loading.value = false;
            if (resp.ok) {
                kardexs.value    = resp.data.rows;
                totalItems.value = resp.data.total;
            }
        };

        // Cuando cambia página o filas por página
        watch(serverOptions, () => { buscarKardex(); }, { deep: true });

        // Búsqueda con debounce — resetea a página 1
        const onSearch = () => {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
                serverOptions.value.page = 1;
                buscarKardex();
            }, 350);
        };

        onMounted(async () => {
            await buscarKardex();
        });

        const nuevaEntrada = () => {
            kardexEditarEntradaSalidaComponentRef.value.abrirComponent('entrada');
        };

        const nuevaSalida = () => {
            kardexEditarEntradaSalidaComponentRef.value.abrirComponent('salida');
        };

        const cerrarKardexEditarEntradaSalidaComponentEmit = async (seGrabo: boolean) => {
            if (seGrabo) await buscarKardex();
        };

        return {
            headers,
            textoFiltro,
            kardexs,
            totalItems,
            loading,
            serverOptions,

            buscarKardex,
            onSearch,
            nuevaEntrada,
            nuevaSalida,

            numeral,

            kardexEditarEntradaSalidaComponentRef,
            cerrarKardexEditarEntradaSalidaComponentEmit,
        };
    },
};
